import React from 'react';

export default(key, lang) => {
  let mapping = {
    title: {
      en_US: 'Set Up Your Phone',
      de_DE: 'Richten Sie Ihr Telefon ein',
      el_GR: 'Ρύθμιση του τηλεφώνου σας',
      es_ES: 'Configura tu teléfono',
      fr_FR: 'Configurez votre téléphone',
      fr_CA: 'Configurez votre téléphone',
      it_IT: 'Configura il tuo telefono',
      pl_PL: 'Skonfiguruj swój telefon',
      th_TH: 'ตั้งค่าโทรศัพท์ของคุณ',
      zh_CN: '设置手机',
      pt_BR: 'Configure o seu telefone',
      ja_JP: '電話を設定する',
    },
    cancelText: {
      en_US: 'Back',
      de_DE: 'Zurück',
      el_GR: 'πίσω',
      es_ES: 'Regresa',
      fr_FR: 'Retourner',
      fr_CA: 'Retourner',
      it_IT: 'Torna Indietro',
      pl_PL: 'Wróć',
      th_TH: 'กลับไป',
      zh_CN: '回去',
      pt_BR: 'Volte',
      ja_JP: '戻る',
    },
    submitText: {
      en_US: 'Next',
      de_DE: 'Nächster',
      el_GR: 'Επόμενο',
      es_ES: 'Próximo',
      fr_FR: 'Prochain',
      fr_CA: 'Prochain',
      it_IT: 'Il prossimo',
      pl_PL: 'Kolejny',
      th_TH: 'ต่อไป',
      zh_CN: '下一个',
      pt_BR: 'Próximo',
      ja_JP: '次に',
    },
    stepText: {
      en_US: 'What phone number do you want to use?',
      de_DE: 'Welche Telefonnummer möchten Sie verwenden?',
      el_GR: 'Τι αριθμό τηλεφώνου θέλετε να χρησιμοποιήσετε;',
      es_ES: '¿Qué número de teléfono quieres usar?',
      fr_FR: 'Quel numéro de téléphone souhaitez-vous utiliser?',
      fr_CA: 'Quel numéro de téléphone souhaitez-vous utiliser?',
      it_IT: 'Quale numero di telefono vuoi usare?',
      pl_PL: 'Z jakiego numeru telefonu chcesz korzystać?',
      th_TH: 'คุณต้องการใช้หมายเลขโทรศัพท์ใด',
      zh_CN: '您要使用什么电话号码？',
      pt_BR: 'Qual número de telefone você deseja usar?',
      ja_JP: 'どの電話番号を使用しますか？',
    },
    stepTextExisting: {
      en_US: 'The Password Recovery phone number will be used for Multi-Factor Authentication. You can change the number but this will also update your Password Recovery phone number.',
      de_DE: 'Die Telefonnummer für die Kennwortwiederherstellung wird für die Multi-Faktor-Authentifizierung verwendet. Sie können die Nummer ändern, dies aktualisiert jedoch auch Ihre Telefonnummer für die Kennwortwiederherstellung.',
      el_GR: 'Ο αριθμός τηλεφώνου για την ανάκτηση κωδικού πρόσβασης θα χρησιμοποιηθεί για έλεγχο ταυτότητας πολλαπλών παραμέτρων. Μπορείτε να αλλάξετε τον αριθμό, αλλά αυτό θα ενημερώσει επίσης τον αριθμό τηλεφώνου ανάκτησης κωδικού πρόσβασης.',
      es_ES: 'El número de teléfono de recuperación de contraseña se utilizará para la autenticación multifactor. Puede cambiar el número, pero esto también actualizará su número de teléfono de Recuperación de contraseña.',
      fr_FR: `Le numéro de téléphone de récupération du mot de passe sera utilisé pour l'authentification multifacteur. Vous pouvez modifier le numéro, mais cela mettra également à jour votre numéro de téléphone de récupération de mot de passe.`,
      fr_CA: `Le numéro de téléphone de récupération du mot de passe sera utilisé pour l'authentification multifacteur. Vous pouvez modifier le numéro, mais cela mettra également à jour votre numéro de téléphone de récupération de mot de passe.`,
      it_IT: `Il numero di telefono per il recupero della password verrà utilizzato per l'autenticazione a più fattori. È possibile modificare il numero ma questo aggiornerà anche il numero di telefono per il recupero della password.`,
      pl_PL: 'Numer telefonu do odzyskiwania hasła zostanie użyty do uwierzytelnienia wieloskładnikowego. Możesz zmienić numer, ale spowoduje to również aktualizację numeru telefonu do odzyskiwania hasła.',
      th_TH: 'หมายเลขโทรศัพท์สำหรับกู้คืนรหัสผ่านจะถูกใช้สำหรับการรับรองความถูกต้องด้วยหลายปัจจัย คุณสามารถเปลี่ยนหมายเลขได้ แต่สิ่งนี้จะอัปเดตหมายเลขโทรศัพท์ของคุณในการกู้คืนรหัสผ่านด้วย',
      zh_CN: '密码恢复电话号码将用于多重身份验证。您可以更改号码，但这也会更新您的密码恢复电话号码。',
      pt_BR: 'O número de telefone da Recuperação de senha será usado para autenticação multifator. Você pode alterar o número, mas isso também atualizará seu número de telefone da Recuperação de senha.',
      ja_JP: 'パスワード復旧の電話番号は、多要素認証に使用されます。番号を変更できますが、これによりパスワード再設定の電話番号も更新されます。',
    },
    invalidNumberMessage: {
      en_US: 'This is not a valid phone number.',
      de_DE: 'Dies ist keine gültige Telefonnummer.',
      el_GR: 'Αυτός δεν είναι έγκυρος αριθμός τηλεφώνου.',
      es_ES: 'Esto no es un número de teléfono válido.',
      fr_FR: "Ce n'est pas un numéro de téléphone valide.",
      fr_CA: "Ce n'est pas un numéro de téléphone valide.",
      it_IT: 'Questo numero di telefono non è valido.',
      pl_PL: 'To nie jest poprawny numer telefonu.',
      th_TH: 'นี่ไม่ใช่หมายเลขโทรศัพท์ที่ถูกต้อง',
      zh_CN: '这不是一个有效的电话号码。',
      pt_BR: 'Este não é um número de telefone válido.',
      ja_JP: 'これは有効な電話番号ではありません。',
    },
    isRequiredMessage: {
      en_US: 'This field is required',
      de_DE: 'Dieses Feld wird benötigt.',
      el_GR: 'Αυτό το πεδίο απαιτείται.',
      es_ES: 'Este campo es requerido.',
      fr_FR: 'Ce champ est requis.',
      fr_CA: 'Ce champ est requis.',
      it_IT: 'Questo campo è obbligatorio.',
      pl_PL: 'To pole jest wymagane.',
      th_TH: 'ต้องระบุข้อมูลในฟิลด์นี้',
      zh_CN: '这是必填栏。',
      pt_BR: 'Este campo é obrigatório.',
      ja_JP: 'この項目は必須です。',
    }
  };
  return mapping[key][lang];
};